// @flow
export const CHECKBOX_THEME_API = {
  root: '',
  disabled: '',
  checked: '',
  input: '',
  check: '',
  label: ''
};
